import { getApiBaseUrl, getClientUrl } from '../../../utils/api';
import { getTsrAdminToken } from '../auth/tsrAdminAuth';
import { getTsrCustomerToken } from '../auth/tsrCustomerAuth';

export function buildApiUrl(path) {
  const separator = path.includes('?') ? '&' : '?';
  const clientUrl = encodeURIComponent(getClientUrl());
  return `${getApiBaseUrl()}${path}${separator}ClientUrl=${clientUrl}`;
}

async function parseJsonResponse(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const message = data?.message || `Request failed (${response.status})`;
    throw new Error(message);
  }
  return data;
}

export async function apiGet(path, options = {}) {
  const response = await fetch(buildApiUrl(path), options);
  return parseJsonResponse(response);
}

export async function apiGetAdmin(path) {
  const token = getTsrAdminToken();
  return apiGet(path, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
}

export async function apiPost(path, body, options = {}) {
  const headers = {
    'Content-Type': 'application/json',
    ...(options.headers || {})
  };

  const response = await fetch(buildApiUrl(path), {
    method: 'POST',
    headers,
    body: JSON.stringify(body)
  });

  return parseJsonResponse(response);
}

export async function apiPostAdmin(path, body) {
  const token = getTsrAdminToken();
  return apiPost(path, body, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
}

export async function apiPostCustomer(path, body) {
  const token = getTsrCustomerToken();
  return apiPost(path, body, {
    headers: token ? { Authorization: `Bearer ${token}` } : {}
  });
}
